import { addDays, isBefore, isSameDay } from 'date-fns'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Icon from '@/utilities/client-components/components/Icon/Icon'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledDueDate = styled.div`
  display: inline-block;
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, `dueDate.${props.priority}.color`)};
  font-size: ${(props: any) => themeUtilities.getFontSize(props.theme, 'dueDate')}px;
  font-weight: ${(props: any) => themeUtilities.getFontWeight(props.theme, 'dueDate.weight')};
`

const StyledIcon = styled(Icon)`
  margin-right: 5px;
  height: ${(props: any) => themeUtilities.getFontSize(props.theme, 'dueDate')}px;
  width: ${(props: any) => themeUtilities.getFontSize(props.theme, 'dueDate')}px;
  fill: ${(props: any) => themeUtilities.getRgbaColor(props.theme, `dueDate.${props.priority}.color`)};
`

interface DueDateProps {
  className?: string
  dueTimestamp?: string
  priority: string
}

const DueDate = ({ className, dueTimestamp, priority }: DueDateProps) => {
  const { t } = useTranslation('client')
  if (!dueTimestamp || !priority) return null

  const today = new Date()
  const tomorrow = addDays(new Date(), 1)
  const endOfWeek = addDays(new Date(), 7)
  const dueDate = new Date(dueTimestamp)

  let dateAsString = ''
  if (isBefore(dueDate, today)) {
    dateAsString = t('client:DueDate.overdue')
  } else if (isSameDay(dueDate, today)) {
    dateAsString = t('client:DueDate.dueToday')
  } else if (isSameDay(dueDate, tomorrow)) {
    dateAsString = t('client:DueDate.dueTomorrow')
  } else if (isBefore(dueDate, endOfWeek)) {
    // Show full day of week like Monday / Tuesday
    dateAsString = t('client:DueDate.dueDayOfWeek', { date: dueDate })
  } else {
    // Ex. Feb 24, Aug 16.
    dateAsString = t('client:DueDate.dueFuture', { date: dueDate })
  }

  if (!priority) {
    return null
  }

  return (
    // @ts-expect-error
    <StyledDueDate className={className} priority={priority}>
      {/* @ts-expect-error */}
      <StyledIcon name="inline-icon-flag" priority={priority} />
      <span>{dateAsString}</span>
    </StyledDueDate>
  )
}

export default DueDate
